// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-policy-needed-modal .modal-dialog{max-width:600px}`, "",{"version":3,"sources":["webpack://./client/Applications/DataGrids/Grids/Forms/PrivacyPolicyNeededModal.scss"],"names":[],"mappings":"AAAA,2CACI,eAAA","sourcesContent":[".privacy-policy-needed-modal .modal-dialog {\n    max-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
